import {
  Grid as MuiGrid,
  GridProps as MuiGridProps,
  GridItemsAlignment as MuiGridItemsAlignment,
} from "@material-ui/core";
import classNames from "classnames";
import { memo } from "react";

import {
  generateClasses,
  GenericOptionalBreakpointValues,
  OptionalBreakpointValues,
} from "../../utilities/functions";

export type GridProps = MuiGridProps & {
  readonly alignSelf?:
    | MuiGridItemsAlignment
    | GenericOptionalBreakpointValues<MuiGridItemsAlignment>;
  readonly spacingInnerTop?: number | OptionalBreakpointValues;
  readonly spacingInnerRight?: number | OptionalBreakpointValues;
  readonly spacingInnerBottom?: number | OptionalBreakpointValues;
  readonly spacingInnerLeft?: number | OptionalBreakpointValues;
  readonly spacingBottom?: number | OptionalBreakpointValues;
};

export const Grid = memo<GridProps>(
  ({
    alignSelf,
    spacingInnerTop,
    spacingInnerRight,
    spacingInnerBottom,
    spacingInnerLeft,
    spacingBottom,
    className,
    ...restProps
  }) => {
    const additionalStyles = generateClasses({
      alignSelf,
      spacingInnerTop,
      spacingInnerRight,
      spacingInnerBottom,
      spacingInnerLeft,
      spacingBottom,
    });

    const classes = classNames(...additionalStyles, className);

    return <MuiGrid {...restProps} className={classes} />;
  }
);
